module.exports = __webpack_public_path__ + "static/media/penWhite.1ffdddfa.svg";